import apiClient from './apiClient';

// ============================================================
// Types — matching backend Go models (backend/modules/pw9319/models/pw9319.go)
// ============================================================

export interface QueryParams {
  empFrom?: string;   // employee code range lower bound (empty = all)
  empTo?: string;     // employee code range upper bound (empty = "zzzz")
  sortOrder?: string; // "card" (by F919_01) or "emp" (by F919_11). Default: "card"
}

// CardCustodyRow — one row from F919 LEFT JOIN F901
// Field names use original FoxPro codes per project coding rules.
export interface CardCustodyRow {
  // From F919 (感應卡資料表)
  F919_01: string;   // card number (CHAR(10))
  F919_11: string;   // employee code (CHAR(8))
  F919_12: string;   // effective date (YYYY-MM-DD)
  F919_13: string;   // expiry date (YYYY-MM-DD)
  F919_91: string;   // creator code (CHAR(8))
  F919_92: string;   // create date (YYYY-MM-DD)

  // From F901 (員工基本資料) via LEFT JOIN on F919_11 = F901_01
  F901_01: string;   // employee code (join key)
  F901_12: string;   // employee name (CHAR(20))
}

export interface QueryResponse {
  data: CardCustodyRow[];
  count: number;
  message?: string;
}

export interface EmployeeOption {
  code: string;
  name: string;
}

// ============================================================
// API methods
// ============================================================

export const pw9319Api = {
  async query(params: QueryParams): Promise<QueryResponse> {
    const res = await apiClient.post('/api/pw9319/query', params);
    return res.data;
  },

  async lookupEmployee(type: string, code: string): Promise<EmployeeOption | null> {
    if (!code || !code.trim()) return null;
    try {
      const res = await apiClient.get(`/api/pw9319/lookup/${encodeURIComponent(type)}/${encodeURIComponent(code.trim())}`);
      return res.data || null;
    } catch {
      return null;
    }
  },
};
